import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Select,
  withStyles,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
  Tooltip,
  FormHelperText,
  Button,
} from '@material-ui/core';

import { FaqIcon } from '../../constants/icons';
import styles from '../../styles';

function StreamBlockForm({ classes, data, submitHandler }) {
  const { id } = data;
  const [name, setName] = useState(data.name);
  const [sort, setSort] = useState(data.sort);
  const [status, setStatus] = useState(data.status);
  const [link, setLink] = useState(data.link);
  const [stream_type, setStreamType] = useState(data.stream_type);
  const [src_type, setSrcType] = useState(data.src_type);
  const [navigationPage, setNavigationPage] = useState(0);

  async function dispatchHandler(event) {
    event.preventDefault();
    
    const ifOk = confirm('Вы уверены что хотите сохранить изменения?');
    if (ifOk) {
      await submitHandler(
        {
          id,
          name,
          sort,
          status,
          link,
          stream_type,
          src_type
        },
      );
    } else {
      history.back();
    }
  }

  return (
    <form onSubmit={dispatchHandler}>
      <div>
        <div className={classes.field}>
          <div className={classes.title}>Имя:</div>
          <TextField
            type="text"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            className={classes.field}
          />
        </div>
        <div className={classes.field}>
          <div className={classes.title}>Тип потока:</div>
          <FormControl className={classes.field}>
            <InputLabel id="select-stream_type" />
            <Select
              labelId="select-stream_type"
              value={stream_type}
              label="Тип потока"
              onChange={(e) => {
                setStreamType(e.target.value);
              }}
            >
              <MenuItem value={"main"}>main</MenuItem>
              <MenuItem value={"offer"}>offer</MenuItem>
              <MenuItem value={"button"}>button</MenuItem>
          </Select>
          </FormControl>
        </div>
        <div className={classes.field}>
          <div className={classes.title}>Позиция:</div>
          <TextField
            type="text"
            value={sort}
            onChange={(e) => {
              setSort(e.target.value);
            }}
            className={classes.field}
          />
        </div>
        <div className={classes.field}>
          <div className={classes.title}>
            Статус видимости <Tooltip title="Отображать на сайт"><FaqIcon fontSize="small" /></Tooltip>:
          </div>
          <FormControl className={classes.field}>
            <InputLabel id="seletc-status" />
            <Select
              required
              labelId="seletc-status"
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
              }}
            >
              <MenuItem value={1}>Видимый</MenuItem>
              <MenuItem value={0}>Невидимый</MenuItem>
            </Select>
          </FormControl>
        </div>
        
        <div className={classes.field}>
          <div className={classes.title}>Src Type:</div>
          <FormControl className={classes.field}>
            <InputLabel id="select-src_type" />
            <Select
              labelId="select-src_type"
              value={src_type}
              label="Src Type"
              onChange={(e) => {
                setSrcType(e.target.value);
              }}
            >
              <MenuItem value={"application/x-mpegurl"}>application/x-mpegurl</MenuItem>
              <MenuItem value={"video/mp4"}>video/mp4</MenuItem>
              <MenuItem value={"video/webm"}>video/webm</MenuItem>
              <MenuItem value={"rtmp/mp4"}>rtmp/mp4</MenuItem>
              <MenuItem value={"video/rtmp"}>video/rtmp</MenuItem>
          </Select>
          </FormControl>
        </div>
        <div className={classes.field}>
          <div className={classes.title}>Ссылка: <Tooltip title="Ссылка по которой будут работать аудио трансляции"><FaqIcon fontSize="small" /></Tooltip></div>
          <TextField
            type="text"
            value={link}
            onChange={(e) => {
              setLink(e.target.value);
            }}
            className={classes.field}
          />
        </div>
        <Button variant="contained" color="primary" type="submit" fullWidth>
          {id ? 'Обновить блок' : 'Создать блок'}
        </Button>
      </div>
      <div />
    </form>
  );
}

StreamBlockForm.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
  submitHandler: PropTypes.func,
};

StreamBlockForm.defaultProps = {
  classes: {},
  data: {
    name: '',
    sort: 0,
    status: 1,
    link: '',
    playlist_link: '',
    quality: 64,
  },
  submitHandler: () => {},
};

export default withStyles(styles)(StreamBlockForm);
